// Onboarding chips — spec §0.2 (v2.5): step 2 topics (no gender question,
// PR #41).
export const ONBOARDING_TAGS = [
  'Тревога', 'Стресс', 'Панические атаки',
  'Подавленность', 'Проблемы со сном', 'Конфликты',
  'Выгорание', 'Навязчивые мысли', 'Самооценка', 'Другое',
]
